var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_236_25764"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: -1.5,
    width: 43,
    height: 43,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_236_25764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,31L29,31L29,18C29,13.029437099999999,24.970563,9,20,9C15.029437099999999,9,11,13.029437099999999,11,18L11,31ZM27.5,29.5L12.5,29.5L12.5,18Q12.5,14.893397799999999,14.6966989,12.6966989Q16.8933983,10.5,19.9999962,10.5Q23.1066,10.5,25.3033,12.6966991Q27.5,14.8933988,27.5,18L27.5,29.5Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 30.25,
    x2: 32,
    y2: 30.25,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#FFFFFF",
    fill: "none",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7864747,21.75L18.82917964,25.6645899L20.1708202,26.33541L23.2135258,20.25L19.2135254,20.25L21.1708202,16.33541018L19.8291796,15.66458982L16.7864745,21.75L20.7864747,21.75Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorIcon);
export default __webpack_public_path__ + "static/media/monitor-icon.df2110a426365bd51fe59b220e19295e.svg";
export { ForwardRef as ReactComponent };